import React from "react";
import {Link} from "react-router-dom";
import classNames from "classnames";

import ReactTable from "react-table";
import {Button} from "reactstrap";
import ClipLoader from 'react-spinners/ClipLoader';
import {Card, CardContent} from "@material-ui/core";

import API from "@beardeddevops/react.api";
import APPCONFIG from "../../constants/Config";
import Framework from "@beardeddevops/react.framework";
import Types from 'constants/Types';

import moment from "moment";


import ReactToPrint from 'react-to-print';

export default class WorkOrders extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Work_Orders._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 16;
		this.limit = 16;
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [
			{
				Header: "Created Date",
				id: "created",
				className: 'center-column',
				accessor: obj => {
					return obj.created ? moment(obj.created).local().format("MM/DD/YYYY") : '-'
				}
			},
			{
				Header: "Customer",
				id: "customer",
				accessor: obj => obj.customers ? obj.customers.name : obj.customer
			},
			{
				Header: "Status",
				id: "status",
				className: 'center-column',
				accessor: obj => obj.status || 'Received'
			},
			{
				Header: "Description",
				id: "description",
				accessor: obj => obj.description
			},
			{
				Header:"Price",
				id: "subtotal",
				className: 'right-column',
				accessor: r => r.subtotal =  "$" + parseFloat(r.amount - r.tax_amount).toFixed(2)
			},
			{
				Header: "Tax",
				id: "tax_amount",
				className: 'right-column',
				accessor: r => (parseFloat(r.tax_amount)) <= 0.00 ? "Non-Taxable" :
					"$" + r.tax_amount
			},
			{
				Header:"Total",
				id: "amount",
				className: 'right-column',
				accessor: r => "$" + r.amount
			},
			{
				Header: "Remaining Amount",
				id: "remaining",
				accessor: r => "$" + r.remaining
			},
			{
				Header: "Est. Completion",
				id: "estimated_date",
				className: 'center-column',
				accessor: obj => {
					return obj.estimated_date ? moment(obj.estimated_date).local().format("MM/DD/YYYY") : '-'
				}
			},
			{
				Header: "Completed Date",
				id: "completed_date",
				className: 'center-column',
				accessor: obj => {
					return obj.completed_date ? moment(obj.completed_date).local().format("MM/DD/YYYY") : '-'
				}

			},

			{
				Header: "Label",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 80,
				Cell: props => {
					const refKey = `woTag_${props.original.pkey}`;
					const customerLabel = props.original.customers ? props.original.customers.name : '';
					return (
						<span>
							<Framework.Printable.Label
								ref={el => (this[refKey] = el)}
								prefix="WO"
								code={props.original.pkey}
								label={customerLabel}
							/>
							<ReactToPrint
								trigger={() =>
									<Button className="secondary-button pull-right" size={"sm"} block={true} style={{ marginTop: '6px' }}>
										<i className={"fa fa-tag"}/>&nbsp;&nbsp;Print
									</Button>
								}
								content={() => this[refKey]}
								copyStyles={false}
								pageStyle={'@media print { body { -webkit-print-color-adjust: exact; margin: 0 } @page { margin: 0 }}'}
								bodyClass={""}
							/>
						</span>
					);
				}
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 60,
				Cell: props => {
					return (
						<span>
							<Link to={`/work-orders/` + props.original.pkey}>
								<Button className="primary-button" size={"sm"} block={true} style={{ marginTop: '6px' }}>View</Button>
							</Link>
						</span>
					);
				}
			},
		];
		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch("Work Orders")}
							{this.renderHeaderRight("Work Orders",columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination= {true}
						showPaginationTop= {false}
						showPaginationBottom= {true}
						showPageSizeOptions= {true}
						defaultPageSize={limit}
						onPageSizeChange={this.onPageSizeChange}
						className="-striped -highlight"
					/>
				</CardContent>
				{APPCONFIG.settings.isDev() ? null :
					<div className={classNames("tabled", "loader", {'active': loading})}>
						<ClipLoader color={"#4A4A4A"} loading={loading}/>
					</div>
				}
			</Card>
		)
	}
}
